import { useEffect, useState } from 'react'
import { Button, Select, Space, Table, Tag, message } from 'antd'
import { cancelJob, listJobs, retryJob } from '../api/client'
import { useDefaultWorkspace } from '../hooks/useDefaultWorkspace'
import type { Job } from '../types'
import { statusColor } from '../utils/status'

export default function JobsPage() {
  const [jobs, setJobs] = useState<Job[]>([])
  const [status, setStatus] = useState<string | undefined>()
  const workspaceId = useDefaultWorkspace()

  const load = async () => {
    const { data } = await listJobs({ status, workspace_id: workspaceId || undefined })
    setJobs(data)
  }

  useEffect(() => {
    load().catch((e) => message.error(e.message))
    const t = setInterval(() => load().catch(() => undefined), 3000)
    return () => clearInterval(t)
  }, [status, workspaceId])

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>任务中心</h2>
        <Space>
          <Select
            allowClear
            placeholder="状态筛选"
            style={{ width: 160 }}
            onChange={setStatus}
            options={[
              { value: 'queued', label: '排队中' },
              { value: 'running', label: '处理中' },
              { value: 'waiting_for_review', label: '待审核' },
              { value: 'succeeded', label: '成功' },
              { value: 'failed', label: '失败' },
              { value: 'interrupted', label: '已中断' },
              { value: 'cancelled', label: '已取消' },
            ]}
          />
          <Button onClick={() => setStatus('failed')}>查看失败任务</Button>
        </Space>
      </div>
      <Table
        rowKey="id"
        dataSource={jobs}
        columns={[
          { title: '类型', dataIndex: 'job_type', width: 180 },
          {
            title: '状态',
            dataIndex: 'status',
            width: 110,
            render: (s: string, r) => <Tag color={statusColor[s]}>{r.status_label || s}</Tag>,
          },
          {
            title: '进度',
            dataIndex: 'progress',
            width: 90,
            render: (p: number) => `${Math.round((p || 0) * 100)}%`,
          },
          { title: '阶段', dataIndex: 'stage', width: 140 },
          { title: '消息', dataIndex: 'message', ellipsis: true },
          {
            title: '错误',
            dataIndex: 'error_detail',
            ellipsis: true,
            render: (v: string, r) => (v ? `${r.error_code || ''}: ${v}` : '-'),
          },
          {
            title: '操作',
            width: 160,
            render: (_, r) => (
              <Space>
                {['failed', 'interrupted', 'cancelled'].includes(r.status) && (
                  <Button
                    size="small"
                    onClick={async () => {
                      await retryJob(r.id)
                      message.success('已重试')
                      await load()
                    }}
                  >
                    重试
                  </Button>
                )}
                {['queued', 'running', 'interrupted'].includes(r.status) && (
                  <Button
                    size="small"
                    danger
                    onClick={async () => {
                      await cancelJob(r.id)
                      message.success('已取消')
                      await load()
                    }}
                  >
                    取消
                  </Button>
                )}
              </Space>
            ),
          },
        ]}
      />
    </div>
  )
}
